import React, { useEffect, useState } from "react";
import "../App.css";
import { useHistory } from "react-router-dom";
import { Typography } from "antd";
import { Radio, Button } from "antd-mobile";
import { withLocalize } from "react-localize-redux";

const { Title } = Typography;

const Language = ({ translate, setActiveLanguage }) => {
  const history = useHistory();
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleChange = (val) => {
    setSelectedLanguage(val);
    setActiveLanguage(val);
    localStorage.setItem("language", val);
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const proceed = () => {
    history.push("/location");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          backgroundColor: "#FFFFFF",
          width: isMobile ? "100%" : "20%",
          padding: "20px",
          boxSizing: "border-box",
          borderRadius: "12px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ width: "100%", maxWidth: "400px" }}>
          <Title level={4} style={{ textAlign: "center", marginBottom: "24px" }}>
            {translate("select_language")}
          </Title>

          <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginBottom: "24px" }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              English
              <Radio
                value="en"
                checked={selectedLanguage === "en"}
                onChange={() => handleChange("en")}
              />
            </label>

            <label
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              اردو
              <Radio
                value="ur"
                checked={selectedLanguage === "ur"}
                onChange={() => handleChange("ur")}
              />
            </label>
          </div>


          <Button block color="primary" size="medium" onClick={proceed}>
            {translate("proceed")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withLocalize(Language);
